package com.wintermar.inspection.core.ui.component.input

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.snapshotFlow
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.input.util.InputState
import com.wintermar.inspection.core.ui.component.input.util.InputStateModel
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_close_circle_fill
import inspection.composeapp.generated.resources.ic_search
import inspection.composeapp.generated.resources.search
import kotlinx.coroutines.FlowPreview
import kotlinx.coroutines.flow.collectLatest
import kotlinx.coroutines.flow.debounce
import org.jetbrains.compose.resources.stringResource
import kotlin.time.Duration.Companion.milliseconds

@OptIn(FlowPreview::class)
@Composable
fun InputSearchText(
    placeholder: String? = null,
    initialValue: String? = null,
    modifier: Modifier = Modifier,
    onTextChanged: (keyword: CharSequence) -> Unit
) {
    val placeholderValue =
        if (placeholder.isNullOrEmpty()) stringResource(Res.string.search) else placeholder
    val scope = rememberCoroutineScope()
    val inputState = remember {
        InputState(
            initialData = InputStateModel(
                placeholder = placeholderValue,
                leadingIcon = Res.drawable.ic_search,
                trailingIconClickable = true,
                value = if (!initialValue.isNullOrEmpty()) initialValue else ""
            ),
            scope
        )
    }

    LaunchedEffect(inputState) {
        snapshotFlow { inputState.value.text }
            .debounce(300.milliseconds)
            .collectLatest { keyword ->
                onTextChanged(keyword)
                inputState.onUpdateTrailingIcon(if (keyword.isNotEmpty()) Res.drawable.ic_close_circle_fill else null)
            }
    }

    InputText(
        state = inputState,
        modifier = modifier,
        onAction = {
            inputState.onClear()
        }
    )
}
